routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.paymentOrders', {
      url: __env.routes.paymentOrders,
      template: `<payment-orders sh-ctrl="shCtrl"></payment-orders>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/payments-advances/payment-orders/payment-orders.config.js